import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { get } from '@/tools/request';
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        getToken();
        async function getToken() {
            try {
                const res = await get({ url: '/common/getToken' });
                sessionStorage.setItem('User-Token', res.data.token);
            }
            catch (error) {
                // ...
            }
        }
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createBlock(_component_router_view));
        };
    }
});
